/** Route slug → backend agent ID */
export const AGENT_ROUTE_TO_ID: Record<string, string> = {
  "architect": "architect",
  "functional": "functional",
  "configuration-server": "configuration_server",
  "code-companion": "code_companion",
};

/** Backend ID → route slug */
export const AGENT_ID_TO_ROUTE: Record<string, string> = {
  architect: "architect",
  functional: "functional",
  configuration_server: "configuration-server",
  code_companion: "code-companion",
};

/** Backend ID → display name */
export const AGENT_DISPLAY_NAMES: Record<string, string> = {
  architect: "Architect",
  functional: "Functional",
  configuration_server: "Configuration Server",
  code_companion: "Code Companion",
};

/** Backend ID → icon name (Lucide) */
export const AGENT_ICONS: Record<string, string> = {
  architect: "Code",
  functional: "Calculator",
  configuration_server: "SlidersHorizontal",
  code_companion: "FolderKanban",
};

/** Get backend agent ID from a route slug like "architect" */
export function getAgentIdFromRoute(routeSlug: string): string {
  return AGENT_ROUTE_TO_ID[routeSlug] ?? routeSlug;
}

/** Get route slug from backend agent ID */
export function getRouteFromAgentId(agentId: string): string {
  return AGENT_ID_TO_ROUTE[agentId] ?? agentId;
}
